import { books } from '@/mocks/books';

export default function Books() {
  return (
    <section id="buecher" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 px-4 py-1.5 text-xs md:text-sm font-semibold">
            <i className="ri-book-2-line"></i>
            Meine Bücher
          </span>
          <div className="mt-4">
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              Zum Weiterlesen – direkt von mir
            </h2>
          </div>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            Zwei Begleiter aus meiner Praxis: ein Mindsettagebuch für den persönlichen
            Weg und ein Fachbuch zur inklusiven Förderung. Beide erhalten Sie direkt bei
            Amazon.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {books.map((book) => (
            <article
              key={book.id}
              className="group flex flex-col sm:flex-row rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full shrink-0 bg-background-100 p-6 flex items-center justify-center sm:w-[42%]">
                <span className="absolute top-4 left-4 rounded-full bg-background-50/95 text-foreground-800 text-xs font-semibold px-3 py-1.5">
                  {book.badge}
                </span>
                <div className="aspect-[1/1.3] w-full max-w-[210px] overflow-hidden rounded-md shadow-[0_18px_38px_-24px_rgba(0,0,0,0.45)]">
                  <img
                    src={book.image}
                    alt={book.title}
                    title={`${book.title} Buch von ${book.author}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-7">
                <p className="text-xs font-semibold uppercase tracking-wide text-primary-700">
                  {book.author}
                </p>
                <h3 className="mt-2 text-xl md:text-2xl font-heading font-semibold text-foreground-950 leading-snug">
                  {book.title}
                </h3>
                <p className="mt-2 text-sm font-medium text-foreground-600">
                  {book.subtitle}
                </p>

                <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                  {book.description}
                </p>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {book.highlights.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-2.5 text-sm text-foreground-700"
                    >
                      <span className="mt-0.5 w-4 h-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 shrink-0">
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="mt-6 pt-6 border-t border-background-200 flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <span className="inline-flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-amazon-fill"></i>
                    {book.availability}
                  </span>
                  <a
                    href={book.url}
                    target="_blank"
                    rel="sponsored noopener noreferrer"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    Bei Amazon ansehen
                    <i className="ri-external-link-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}